import React, { useState, useEffect,useRef } from "react";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../../../shared/breadCrumbs/BreadCrumbs";
import { useNavigate } from "react-router";
import { TopBar } from "../../../shared/topBar/TopBar";
import { useDispatch, useSelector } from "react-redux";
import { getMarketDataDetails,getAllMarketDataIndices } from '../../../actions/marketDataAction';
import { UrlPath } from "../../../../config/routeConfig";
import { SBAComboBox, SBADropDown } from "../../../UiComponents/SBADropDown";
import Form from 'react-bootstrap/Form';
import { AgGridReact } from 'ag-grid-react';
import { getAssetSettings, getBenchmarkEntities } from '../../../actions/assetSettingsAction';
import"../marketData/MarketSettings.css";
import { ToastContainer, toast } from 'react-toastify';
import { DeleteAssetBMSetting, InsertAssetBMSetting} from "../../../../config/apiConfig";
import { sbaAxios } from "../../../utils/sbaAxios";
export const MarketDataSettings =()=>
{
    const params = useParams();
    const history = useNavigate();
    const dispatch = useDispatch();
    let Level = ([{ BreadCrumb: "Market Data Settings >", Routes: `${UrlPath.MarketData}` }]);

    const marketIndexId=params.MarketIndexId;
    useEffect(() => {
        dispatch(getAllMarketDataIndices());  
       dispatch(getMarketDataDetails(marketIndexId));
        dispatch(getAssetSettings(params.MarketIndexId, 3));
        dispatch(getBenchmarkEntities(null, "benchMark"));
       }, []);
    const selectedMkIndexApi = useRef();
    const TotalMKIndexApi = useRef();
    const Gstate = useSelector(state => state);
    const marketindicesddl = Gstate.Marketdata.Indices;
    

    const Marketdatadetails = Gstate.Marketdata.Marketdatadetails || [];
    const [marketlistdata, setmarketlistdata] = useState([]);
    const [marketindexId, setmarketindexId] = useState();
    const [marketddldata, setmarketddldata] = useState([]);
    const AssetSettings = useSelector(state => state.assetSettings);
    const benchmarkEntities = AssetSettings.benchMarkEntities;
    const additionalBM = AssetSettings.additionalBM;
    const ASetting = AssetSettings.assetSetting || {};
    const marketIndexBM = AssetSettings.assetSetting.Benchmarks || [];
   
    const [MarketBM, setMarketBM] = useState([]);
    const [SelectedMarketBM, setSelectedMarketBM] = useState([]);
    const [MARBM, setMARBM] = useState();
    const [RFRBM, setRFRBM] = useState();
    const [RFRValue, setRFRValue] = useState({
        isFixed: true, fValue: null, VariableValue: {

        }
    });
    const [MARValue, setMARValue] = useState({ isFixed: true, fValue: null, VariableValue: {} });
    useEffect(() => {
        setmarketddldata({ MarketIndexName: Marketdatadetails?.MarketIndexName, MarketIndexId: Marketdatadetails?.MarketIndexId });
    }, [Marketdatadetails]);
    useEffect(() => {              
    setMarketBM(() => benchmarkEntities);  
    setRFRBM(() => additionalBM);
    setMARBM(() => additionalBM);
    }, [benchmarkEntities, additionalBM, Gstate]);
   useEffect(() => {
    setSelectedMarketBM(marketIndexBM.map((item, index) => {
        return { ...item, "rowIndex": index, BenchMarkXRefId: 0, BMEntityId: item.BMEntityId, BMEntityTypeId: item.BMEntityTypeId, EntityTypeId: 3, EntityId: parseInt(params.MarketIndexId) }
    }));
    setRFRValue({
        isFixed: ASetting.IsRFRFixedRate, fValue: ASetting.RFR, VariableValue: {
            AccountTypeId: 0,
            MarketIndexId: ASetting.RFRBenchmark,
            MarketIndexName:ASetting.RFRBenchmarkName,
            AssetType: 0,
            AssetValue: 0,
        }
    });
    setMARValue({
        isFixed: ASetting.IsMARFixedRate, fValue: ASetting.MAR, VariableValue: {
            AccountTypeId: 0,
            MarketIndexId: ASetting.MARBenchmark,
            MarketIndexName: ASetting.MARBenchmarkName,
            AssetType: 0,
            AssetValue: 0,
        }
    });
}, [ASetting]);


const Searchdata= (e) => {
    const search = e.target.value;
    search.length > 0 && dispatch(getBenchmarkEntities(search, "benchMark"));
    search.length === 0 && setMarketBM([]);
}

const endDatevalueFormatter = (props) => {
    const date = props.data.EndDate;
    let monthName = "";
    let year = "";
    let convertedDate;
    let outPut = "";
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    if (date !== null) {
        convertedDate = new Date(date);
        monthName = monthNames[convertedDate.getMonth()];
        year = convertedDate.getFullYear();
        outPut = monthName + "-" + year;
    }
    return (
        <div>{outPut
        }</div>
    );
};


const startDatevalueFormatter = (props) => {
    const date = props.data.EndDate;
    let monthName = "";
    let year = "";
    let convertedDate;
    let outPut = "";
    const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    if (date !== null) {
        convertedDate = new Date(date);
        monthName = monthNames[convertedDate.getMonth()];
        year = convertedDate.getFullYear();
        outPut = monthName + "-" + year;
    }
    return (
        <div>{outPut
        }</div>
    );
};
const marketBMcolDef = [
    { field: "rowNumber", headerName: "", valueGetter: 'node.rowIndex+1', flex: 0.2 },
    { field: "BenchmarkEntityName", headerName: "Name", flex: 2, resizable: true },
    { field: "BenchmarkEntityType", headerName: "Entity Type" },
    { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter },
    { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
];


const selectedMarketcolDef = [
    {
        rowDrag: true,
        field: "", headerName: "Selected", width: 110, valueGetter: function (params) {
            const rowIndex = params.node.rowIndex + 1;
            const IsPME = params.data.BenchMarkXRefTypeId == 4;
            if (rowIndex == 1) {
                if (IsPME)
                    return "PME ";
                else
                    return "Primary";
            }
            else if (rowIndex == 2) {
                if (IsPME)
                    return "PME";
                else
                    return "Secondary";
            }
            else {
                if (IsPME)
                    return `PME`;
                else
                    return `Addl BM ${rowIndex - 2}`;
            }
        },
        flex: 1.5
    },
    { field: "BMEntityName", headerName: "Name", flex: 2 },
    { field: "BenchmarkTypeName", headerName: "Entity Type", },
    { field: "StartDate", headerName: "Start Date", cellRenderer: startDatevalueFormatter, },
    { field: "EndDate", headerName: "End Date", cellRenderer: endDatevalueFormatter },
];
const defaultColDef = {
    sortable: true, filter: true, flex: 1,resizable:true
}

const addMarketIndex = (e) => {    
    const newBenchMarkIndex = TotalMKIndexApi.current.api.getSelectedRows()[0];
        newBenchMarkIndex && addSelectedMarketIndex(newBenchMarkIndex);
   
}
const addSelectedMarketIndex = (newBenchMarkIndex) => {
    const toAdd = {
        'rowIndex': SelectedMarketBM.length,
        "AssetId": 0,
        "BenchMarkXRefId": 0,
        "BenchMarkXRefTypeId": 0,
        "BenchmarkTypeName": newBenchMarkIndex.BenchmarkEntityType,
        "EntityTypeId": 3,
        "EntityTypeName": null,
        "EntityId": parseInt(params.MarketIndexId),
        "EntityName":null,
        "IsFixedRate": false,
        "BMEntityTypeId": newBenchMarkIndex.BenchmarkEntityTypeId,
        "BMEntityTypeName": newBenchMarkIndex.BenchmarkEntityType,
        "BMRanking": "primary",
        "BMEntityId": newBenchMarkIndex.BenchmarkEntityId,
        "BMEntityName":  newBenchMarkIndex.BenchmarkEntityName,
        "BMValue": 0,
        "IsMrktEqBM": false,
        "SortOrder": SelectedMarketBM.length,
        "StartDate": newBenchMarkIndex.StartDate,
        "EndDate": newBenchMarkIndex.EndDate,
        "RFRBenchmark": null,
        "RFRBenchmarkName": null,
        "MARBenchmark": null,
        "MARBenchmarkName": null,
        "RFR": null,
        "MAR": null,
        "ModifiedBy": 38,
        "ModifiedByName": null,
        "ModifiedDate": (new Date()).toISOString,
    };
   
        setSelectedMarketBM((pv) => {
            return [...pv, { ...toAdd }]
        });
  
    
}
const removeSelectedMarketIndex = (Mkindex) => {
    setSelectedMarketBM(pv => ((pv.filter(item => item.rowIndex !== Mkindex.rowIndex).map((item, index) => { return { ...item, rowIndex: index, SortOrder: index } }))));
}
const MktIndexGridRowDoubleClicked = (e) => {
    addMarketIndex(e.data);
}
const removeMarketIndex = () => {
    const MkIndex = selectedMkIndexApi.current.api.getSelectedRows()[0];
    MkIndex && removeSelectedMarketIndex(MkIndex);
}
const SMktIndexGridRowDoubleClicked = (row) => {
    removeSelectedMarketIndex(row.data);
}

const handleRowDragEnd = (params) => {
    const rows = [];
    selectedMkIndexApi.current.api.forEachNodeAfterFilterAndSort((node) => rows.push(node.data));
    const OrderedRows=rows.map((data,index)=>{
        if(data.BenchMarkXRefTypeId===4)
        {
        data.rowIndex=99; 
        data.SortOrder=99;
        }
        else
        {
        data.rowIndex=index; 
        data.SortOrder=index;
        }
        return{...data}
        }).sort((a, b) => a.rowIndex - b.rowIndex) 
    setSelectedMarketBM(OrderedRows);
};
const saveSelectedMkIndex = async () => {
    let saveSuccess = true;
    let errorMsg = [];
    let bmItems = [...SelectedMarketBM];
    bmItems.push({
        "rowIndex": 11,
        "BenchMarkXRefId": 0,
        "BenchMarkXRefTypeId": 1,
        "BenchmarkTypeName": null,
        "EntityTypeId":3,
        "EntityTypeName": null,
        "EntityId": parseInt(params.MarketIndexId),
        "EntityName": null,
        "IsFixedRate": RFRValue.isFixed,
        "BMEntityTypeId": RFRValue.isFixed ? 0 : 1,
        "BMEntityTypeName": null,
        "BMRanking": null,
        "BMEntityId": RFRValue.isFixed ? 0 : RFRValue.VariableValue ? RFRValue.VariableValue.MarketIndexId : 0,
        "BMEntityName": null,
        "BMValue": RFRValue.isFixed ? parseFloat(RFRValue.fValue) : 0,
        "IsMrktEqBM": false,
        "SortOrder": 0,
        "StartDate": null,
        "EndDate": null,
        "RFRBenchmark": null,
        "RFRBenchmarkName": null,
        "MARBenchmark": null,
        "MARBenchmarkName": null,
        "RFR": null,
        "MAR": null,
        "ModifiedBy": 32,
        "ModifiedByName": null,
        "ModifiedDate": (new Date()).toISOString,
    });

    bmItems.push({
        "rowIndex": 12,
        "BenchMarkXRefId": 0,
        "BenchMarkXRefTypeId": 2,
        "BenchmarkTypeName": null,
        "EntityTypeId": 3,
        "EntityTypeName": null,
        "EntityId": parseInt(params.MarketIndexId),
        "EntityName": null,
        "IsFixedRate": MARValue.isFixed,
        "BMEntityTypeId": MARValue.isFixed ? 0 : 1,
        "BMEntityTypeName": null,
        "BMRanking": null,
        "BMEntityId": MARValue.isFixed ? 0 : MARValue.VariableValue ? MARValue.VariableValue.MarketIndexId : 0,
        "BMEntityName": null,
        "BMValue": MARValue.isFixed ? parseFloat(MARValue.fValue) : 0,
        "IsMrktEqBM": false,
        "SortOrder": 0,
        "StartDate": null,
        "EndDate": null,
        "RFRBenchmark": null,
        "RFRBenchmarkName": null,
        "MARBenchmark": null,
        "MARBenchmarkName": null,
        "RFR": null,
        "MAR": null,
        "ModifiedBy": 32,
        "ModifiedByName": null,
        "ModifiedDate": (new Date()).toISOString,
    });
    const newArray = bmItems.map(item => {
        return {
            "benchMarkXRefId": item.BenchMarkXRefId || 0,
            "benchMarkXRefTypeId": item.BenchMarkXRefTypeId || 0,
            "entityTypeId": 3,
            "entityId": item.EntityId || 0,
            "isFixedRate": item.IsFixedRate,
            "bmEntityTypeId": item.BMEntityTypeId || 0,
            "bmEntityId": item.BMEntityId || 0,
            "bmValue": item.BMValue || 0,
            "isMrktEqBM": item.IsMrktEqBM,
            "sortOrder": item.SortOrder || 0,
            "modifiedBy": item.ModifiedBy
        }
    });
    if (SelectedMarketBM.length===0) {
        saveSuccess = false;
        errorMsg.push("Please Select atleast one BenchMark");
}
    
    if (RFRValue.isFixed) {
        if (RFRValue.fValue == null || RFRValue.fValue == "") {
            saveSuccess = false;
            errorMsg.push("Plesse Add RFR Type Value");
        }
    }
    else if (!RFRValue.isFixed) {
        if (RFRValue.VariableValue.MarketIndexId == undefined || RFRValue.VariableValue.MarketIndexId == 0 || RFRValue.VariableValue.MarketIndexId == null) {
            saveSuccess = false;
            errorMsg.push("Plesse Add RFR Variable Value");
        }
    }
    if (MARValue.isFixed) {
        if (MARValue.fValue == "" || MARValue.fValue == null) {
            saveSuccess = false;
            errorMsg.push("Plesse Add MAR Type Value");
        }
    }
    else if (!MARValue.isFixed) {
        if (MARValue.VariableValue.MarketIndexId == undefined || MARValue.VariableValue.MarketIndexId == 0 || MARValue.VariableValue.MarketIndexId == null) {
            saveSuccess = false;
            errorMsg.push("Plesse Add MAR Variable Value");
        }
    }

    if (saveSuccess) {

        
        await sbaAxios({
            url: `${DeleteAssetBMSetting}${params.MarketIndexId},3`,
            method: 'get'}).then(response => {
            console.log(response, 'Data deleted successfully');
        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
            await  sbaAxios({
                url: `${InsertAssetBMSetting}`,
                method: 'post',
                data: newArray,
            })
        
                .then((response) => {                                
                toast.success('Data  Successfully Saved', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            }).catch((error) => { console.log(error) });
            setTimeout(() => {
                history(`${UrlPath.MarketDataDetails}${params.MarketIndexId}`);
              }, 1000);
    }
    else {
        toast.error(errorMsg.join("\n "), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
        })
    }
};
   //cancel Button
   const NavigatetoDetails = () => {
    history(`${UrlPath.MarketDataDetails}${params.MarketIndexId}`);
};
    const IndexOnchange = (e) => {
        
    e.value
      ? history(`${UrlPath.MarketDataSettings}${e.value.MarketIndexId}`)
      : history(`${UrlPath.MarketDataSettings}${params.MarketIndexId}`);
        setmarketddldata(e.value)
        dispatch(getMarketDataDetails(e.value.MarketIndexId));
        dispatch(getAssetSettings(e.value.MarketIndexId, 3));
        setMarketBM([]);


  };
const setPME = (rowIndex) => {
    let sortOder = -1;
    setSelectedMarketBM(
        SelectedMarketBM.map(item => {
            if (item.rowIndex == rowIndex)
                return {
                    ...item, BenchMarkXRefTypeId: 4,rowIndex:99 ,SortOrder: 99
                }
            else {
                sortOder++;
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: sortOder , rowIndex:sortOder }
            }
        }).sort((a, b) => a.rowIndex - b.rowIndex)
    );
}
const removePME = (rowIndex) => {
    let sortOder = -1;
    const selectedMkIndexcount = SelectedMarketBM.length;
    setSelectedMarketBM(
        SelectedMarketBM.map(item => {
            if (item.rowIndex == rowIndex)
                return {
                    ...item, BenchMarkXRefTypeId: 0, SortOrder: selectedMkIndexcount
                }
            else {
                sortOder++;
                return { ...item, BenchMarkXRefTypeId: 0, SortOrder: sortOder }
            }
        }).sort((a, b) => a.SortOrder - b.SortOrder)
    );
}
const getContextMenuItems = (params) => {
    const rowIndex = params.node.data.rowIndex;
    const isPME = params.node.data.BenchMarkXRefTypeId === 4;
    var setPMEMenu = [
        {
            name: 'Set PME',
            action: () => {
                setPME(rowIndex);
            },
            cssClasses: ['benchmark', 'highlight', 'bold'],
        },
    ];
    var removePMEMenu = [
        {
            name: 'Set BM',
            action: () => {
                removePME(rowIndex);
            },
            cssClasses: ['benchmark', 'highlight', 'bold'],
        },
    ];
    if (isPME)
        return removePMEMenu;
    else
        return setPMEMenu;
};
const getAdditionalBM = (e) => {
    const search = e.filter.value;
    search.length > 3 && dispatch(getBenchmarkEntities(search, "AdditionalbenchMark"));
}
   Level =  ([...Level, { BreadCrumb: `${Marketdatadetails?.MarketIndexName}`, Routes: `${UrlPath.MarketDataDetails}${params.MarketIndexId}` }])


  
   return(<div>
        <TopBar label={"Market Data Settings"} />
        <div id="MarketSetting" className='container-fluid px-3 mainContentData'>
            <BreadCrumbs Levels={Level} />
            <div className='headingGroup d-flex flex-column'>
                        <div className='lineDiv'>
                            <label id="WarningLabel"></label>
                        </div>
            <div className='row my-1'>
                            <div className="col-md-3 pe-0">
                                <label className='label'>Select Market</label>
                                <div>
                                <SBAComboBox
              data={marketindicesddl}
              textField={'MarketIndexName'}
              valueField={'MarketIndexId'}
              value={marketddldata}
              onChange={IndexOnchange}
            />
                                </div>
                            </div>
                            <div className="col-md-9 text-end">
                                <button className='p-sm-btn mx-1' onClick={saveSelectedMkIndex}>Save</button>
                                <button className="s-sm-btn mx-1" onClick={NavigatetoDetails}> Cancel</button>
                            </div>

                        </div>
                        <div className='d-flex flex-column lineDiv my-1'>
                            <div className="row px-0 mx-0">
                                <div className="col-md-3 px-0">
                                    <Form.Control type="text" placeholder="Select Benchmark..." onKeyUp={Searchdata}  className='w-100 flex-grow-1 input-default' />
                                </div>
                            </div>
                        </div>
            
          </div>
          <div className='gridcontent d-flex flex-row mt-3' >
                        <div className='gridDiv' >
                            <div className=''>Available BenchMarks</div>
                            <div className="griddata ag-theme-alpine" style={{ height: '20rem' }}>
                                <AgGridReact
                                    columnDefs={marketBMcolDef}
                                    rowData={MarketBM}
                                     defaultColDef={defaultColDef}
                                    onRowDoubleClicked={MktIndexGridRowDoubleClicked}
                                    rowSelection={'single'}
                                    ref={TotalMKIndexApi}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                        <div className='d-flex flex-column justify-content-center px-3'>
                            <button className='p-sm-btn my-1' onClick={addMarketIndex}>
                            <i class="fa-solid fa-arrow-right"></i>
                            </button>
                            <button className='p-sm-btn my-1' onClick={removeMarketIndex}>
                            <i class="fa-solid fa-arrow-left"></i>
                            </button>

                        </div>
                        <div className='gridDiv'>
                            <div className=''>
                                Selected BenchMarks
                            </div>
                            <div className='griddata ag-theme-alpine' style={{ height: '20rem' }}>
                                <AgGridReact
                                    columnDefs={selectedMarketcolDef}
                                     rowData={SelectedMarketBM}
                                   defaultColDef={defaultColDef}
                                    onRowDoubleClicked={SMktIndexGridRowDoubleClicked}
                                     rowSelection={'single'}
                                    ref={selectedMkIndexApi}
                                  rowDragManaged={true}
                                    animateRows={true}
                                   onRowDragEnd={handleRowDragEnd}
                                     allowContextMenuWithControlKey={true}
                                    getContextMenuItems={getContextMenuItems}
                                     onGridReady={(params) => {
                                         params.api.sizeColumnsToFit()
                                     }}
                                    onRowDragLeave={handleRowDragEnd}
                                >
                                </AgGridReact>
                            </div>
                        </div>
                    </div>   
                    <div className='footerContent row mt-3' >
                        <div className='col-md-4'>
                            <TypeSection name={"RFR Type"} VariableValue={RFRBM} radioName={"RfrType"} onEnter={getAdditionalBM} value={RFRValue} setValue={setRFRValue} />
                        </div>
                        <div className='col-md-4'>
                            <TypeSection name={"MAR Type"} VariableValue={MARBM} radioName={"MarType"} onEnter={getAdditionalBM} value={MARValue} setValue={setMARValue} />
                        </div>
                    </div>   
                </div> 
                <ToastContainer></ToastContainer>       
      </div>)

}

const TypeSection = ({ name, VariableValue, radioName, value, setValue }) => {
    const indexlist = useSelector(state =>state.Marketdata.Indices);
    const indexOnchange = (e) => {
        if (e.value.MarketIndexName === "") {
            const emptyMarket = {
                AccountTypeId: 0,
                MarketIndexId: 0,
                MarketIndexName: "",
                MarketIndeType: null,
                MarketIndexValue: null
            }
            setValue({ ...value, VariableValue: emptyMarket });
        }
        else {
            setValue({ ...value, VariableValue: e.value });
        }
       

    }
    const fixedValueChanged = (e) => {
        setValue({ ...value, fValue: e.target.value });
    }
    const radioButtonChanged = () => {
        setValue({ ...value, isFixed: !value.isFixed });
    }
    return (
        <div className='d-flex flex-column footerItem'>
            <label className='label'>{name} </label>
            <div className='d-flex flex-row '>
                <div className='d-flex flex-column' >
                <span>
                        <input type='radio' name={radioName} checked={value.isFixed} onChange={radioButtonChanged} /><label className='label ms-3'>Fixed</label>
                    </span>
                    <span className='d-flex flex-row' >
                        <Form.Control type="number" placeholder="" defaultValue={value.fValue} disabled={!value.isFixed} className="w-50 input-default" onKeyUp={fixedValueChanged} /><span className="mx-1">%</span>
                    </span>
                </div>
                <div className='d-flex flex-column' style={{width:"50%"}}>
                <span>
                        <input type='radio' name={radioName} checked={!value.isFixed} onClick={radioButtonChanged} /><label className='label ms-3'>Variable</label>
                    </span>
                    <span className='d-flex flex-row'>
                     <SBADropDown className="custom-dropdown-width" value={value.VariableValue} data={indexlist}   textField={'MarketIndexName'}
              dataItemKey={'MarketIndexId'} disabled={value?.isFixed} onChange={indexOnchange}/> 
             </span>
                    
                </div>
            </div>
        </div>
    )
}